(function () {
  const table = '#events-list';

  const outingEventsDatatableApp = function () {
    const baseUrl = () => {
      let url = '/outings/events.json?';
      if (gon.course_id) url += `course_id=${gon.course_id}`;
      return url;
    };
    const init = () => {
      $('#home_course_id').on('change', function () {
        if (!$(this).val()) return;

        window.location.href = `/outings?course_id=${$(this).val()}`;
      });

      // #course-admin-th
      window.eventsDatatable = $(table)
        .DataTable({
          info: false,
          pageLength: 100,
          lengthMenu: [5, 10, 25, 50, 100],
          ajax: {
            url: baseUrl(),
          },
          order: false,
          columns: [
            {
              data: (data) =>
                $('<a>')
                  .attr('href', `/outings/events/${data.id}`)
                  .attr('data-turbolinks', 'false')
                  .text(data.name)
                  .prop('outerHTML'),
            },
            $('#course-admin-th').length > 0 ? { data: 'home_course_name', } : null,
            {
              data: 'code',
            },
            {
              data: 'event_date',
            },
            {
              data: 'players_count',
            },
            {
              data: 'teams_count',
            },
            {
              data: function (data) {
                let pencilColor = 'text-primary';
                if (data.serie_ids && data.serie_ids.length > 0)
                  pencilColor = 'text-warning';
                data.pencilColor = pencilColor;
                return Mustache.render(
                  $('#mustache_events_actions').html(),
                  data
                );
              },
            },
          ].filter(data => data !== null),
        })
        .on('draw.dt', window.bindDatatableTooltips);
    };

    const bindSearch = () => {
      $('form.search-event').on('submit', function (e) {
        e.preventDefault();

        const searchValue = $(this).find('input').val();
        const newUrl = `${baseUrl()}&search=${searchValue}`;
        window.eventsDatatable.ajax.url(newUrl);
        window.eventsDatatable.ajax.reload();
      });
    };

    $(document).on('turbolinks:load', () => {
      if (!$('body').hasClass('controller-outings-events action-index')) return;

      init();
      bindSearch();
    });
  };

  if (typeof window !== 'undefined') {
    window.outingEventsDatatableApp = outingEventsDatatableApp();
  }
})();
